import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: var(--primary-dark);
  color: var(--white);
  padding: var(--spacing-xxl) 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--spacing-xl);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const FooterLogo = styled(Link)`
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--white);
  margin-bottom: var(--spacing-lg);
  display: block;
  text-decoration: none;
  
  img {
    height: 40px;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterTitle = styled.h4`
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-md);
  color: var(--white);
`;

const FooterLink = styled(Link)`
  color: var(--white);
  opacity: 0.8;
  margin-bottom: var(--spacing-sm);
  transition: opacity var(--transition-fast);
  text-decoration: none;
  
  &:hover {
    opacity: 1;
    color: var(--white);
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: var(--spacing-xl) auto 0;
  padding: var(--spacing-lg) var(--spacing-lg) 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const FooterCopyright = styled.p`
  color: var(--white);
  opacity: 0.8;
  font-size: var(--font-size-sm);
  
  @media (max-width: 768px) {
    margin-bottom: var(--spacing-md);
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: var(--spacing-md);
`;

const SocialLink = styled.a`
  color: var(--white);
  font-size: var(--font-size-lg);
  opacity: 0.8;
  transition: opacity var(--transition-fast);
  
  &:hover {
    opacity: 1;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <FooterLogo to="/">Leadfy</FooterLogo>
          <FooterCopyright>
            Transformando atendimento ao cliente com IA
          </FooterCopyright>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Indústrias</FooterTitle>
          <FooterLink to="/solutions/saas">SaaS</FooterLink>
          <FooterLink to="/solutions/ecommerce-retail">E-commerce & Varejo</FooterLink>
          <FooterLink to="/solutions/fintech">Fintech</FooterLink>
          <FooterLink to="/solutions/healthcare">Saúde</FooterLink>
          <FooterLink to="/solutions/mobile-apps">Apps Móveis</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Funções</FooterTitle>
          <FooterLink to="/solutions/cx-teams">Equipes de CX</FooterLink>
          <FooterLink to="/solutions/support-agents">Agentes de Suporte</FooterLink>
          <FooterLink to="/solutions/operations">Operações</FooterLink>
          <FooterLink to="/solutions/security-it">Segurança & TI</FooterLink>
          <FooterLink to="/solutions/content-management">Gestão de Conteúdo</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Plataforma</FooterTitle>
          <FooterLink to="/agents/discover">Discover</FooterLink>
          <FooterLink to="/agents/solve">Solve</FooterLink>
          <FooterLink to="/agents/triage">Triage</FooterLink>
          <FooterLink to="/agents/assist">Assist</FooterLink>
          <FooterLink to="/security">Segurança & Compliance</FooterLink>
          <FooterLink to="/integrations">Integrações</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Recursos</FooterTitle>
          <FooterLink to="/blog">Blog</FooterLink>
          <FooterLink to="/webinars">Webinars</FooterLink>
          <FooterLink to="/customer-stories">Casos de Clientes</FooterLink>
          <FooterLink to="/support">Suporte</FooterLink>
          <FooterLink to="/faqs">FAQs</FooterLink>
        </FooterColumn>
      </FooterContent>
      
      <FooterBottom>
        <FooterCopyright>
          &copy; {new Date().getFullYear()} Leadfy. Todos os direitos reservados.
        </FooterCopyright>
        
        <SocialLinks>
          <SocialLink href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook"></i>
          </SocialLink>
          <SocialLink href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <i className="fab fa-twitter"></i>
          </SocialLink>
          <SocialLink href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="fab fa-linkedin"></i>
          </SocialLink>
        </SocialLinks>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
